module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Price1-dbb6bd5a7febcb3cc6c69b1039247f75.svg";